import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const LinkIcon = createSvgIcon(
  <>
    <path d="M1.99352 5C1.99352 3.29 3.45194 1.9 5.2461 1.9H9.44299V0H5.2461C2.35025 0 0 2.24 0 5C0 7.76 2.35025 10 5.2461 10H9.44299V8.1H5.2461C3.45194 8.1 1.99352 6.71 1.99352 5ZM6.29532 6H14.6891V4H6.29532V6ZM15.7383 0H11.5414V1.9H15.7383C17.5325 1.9 18.9909 3.29 18.9909 5C18.9909 6.71 17.5325 8.1 15.7383 8.1H11.5414V10H15.7383C18.6342 10 20.9844 7.76 20.9844 5C20.9844 2.24 18.6342 0 15.7383 0Z" />
  </>,
  "LinkIcon"
);

export default LinkIcon;
